import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { Indent } from "./indent-entity";
import { IndentFabricEntity } from "./indent-fabric-entity";
import { IndentTrimsEntity } from "./indent-trims-entity";

@Entity('indent_trim_files')
export class IndentTrimsFilesEntity {

@PrimaryGeneratedColumn("increment", { name: 'id' })
id: number;

@Column("varchar", {
    nullable: true,
    length: 255,
    name: "file_name"
    })
    fileName: string;

@Column("varchar", {
    nullable: true,
    length: 255,
    name: "file_path"
    })
    filePath: string;
 

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;



  @ManyToOne(type => IndentTrimsEntity, i => i.iTrimInfo, { nullable: false, })
  @JoinColumn({ name: "itrim_id" })
  indentInfo: IndentTrimsEntity;
}
